import  { useState, useEffect } from "react";
import WarReportMobile from "./WarReportMobile";
import Button from "@mui/material/Button";
import CardContent from "@mui/material/CardContent";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Autocomplete,
} from "@mui/material";
import axios from "axios";
import "./WarReport.css";
import { useLocalStorage } from "@uidotdev/usehooks";
import isDesktop from "../isDesktop";
import { toast, ToastContainer } from "react-toastify";
import { hasStoredTabAccess } from '../utils/access';

const WarReport = ({users}) => {
  const isDesktopDevice = isDesktop();
  const [skills, setSkills] = useState([]);
  const [selectedSkill, setSelectedSkill] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [token,setToken] = useLocalStorage('token',null);
  const [filter, setFilter] = useState(null);
  const [wars, setWars] = useState([]);
  const [selectedWar, setSelectedWar] = useState("");
  const [reports, setReports] = useState([]);
  const isAuthorized = hasStoredTabAccess('Report');

  const handleInputChange = (e, value) => {
    setFilter(value?.username);
  };

  const fetchSkills = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/skills/all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setSkills(response.data.data);
      } else {
        console.error("Error fetching skills: ", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching skills: ", error);
    }
  };

  const fetchWars = async (skillId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/war/all/${skillId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setWars(response.data.data);
        console.log(response.data.data, " got the wars");
      } else {
        console.error("Error fetching wars:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching wars:", error);
    }
  };


  const handleSkillChange = (event) => {
    const selectedSkillId = event.target.value;
    setSelectedSkill(selectedSkillId);
    fetchWars(selectedSkillId);
  };

  const handleExportClick = async () => {
    if(selectedSkill.length === 0){
      toast.error("No skill selected");
      return;
    }
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/report/export-war`,
        {
          name: filter,
          war_id: selectedWar,
          skill_id: selectedSkill,
        },
        {
          responseType: "blob",
        }
      );
      // if(response.data) fetchReports();
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "WarAttempts.xlsx");
      document.body.appendChild(link);
      link.click();
      console.log("File exported successfully");
    } catch (error) {
      console.error("Error exporting file:", error);
      if (error.response.status==400) {
        toast.error("No Data Available")
      }
    }
  };

  useEffect(() => {
    if(isDesktopDevice && isAuthorized) {
      fetchSkills();
      // fetchReports();
    }
  }, [isAuthorized, isDesktopDevice]);

  const handleReset = () => {
    setReports([]);
    setFilter("");
    setSelectedSkill("");
    setSelectedWar("");
  };

  if(!isAuthorized) {
    return (
      <div className="container-fluid mt-5">
        <h2>You are unauthorized to access this page</h2>
      </div>
    )
  }

  function formatTime(date) {
    date = new Date(date);
    // Add 5 hours and 30 minutes
    let ISTOffset = 5.5 * 60 * 60 * 1000; // in ms
    date = new Date(date.getTime() + ISTOffset);
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let AmOrPm = hours >= 12 ? 'pm' : 'am';
    hours = (hours % 12) || 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let formattedTime = `${hours}:${minutes}${AmOrPm}`;
    return formattedTime;
  }  
  return (
    <>
    {
      isDesktopDevice ? (
        <div className="container-fluid mt-3 p-0">
          <ToastContainer />
      <div className="align-center-all full-height">
          <CardContent style={{padding: '0'}}>
            <div className="filters">
            <div className="sub-title">War Report</div>
            <div
              style=
              {{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}
            >
              <div className="fieldContainer">
                <div className="leftFields">
                <FormControl
                  fullWidth
                  className="mb-3 customTextfield"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: 'transparent',
                      },
                      '&:hover fieldset': {
                        borderColor: 'transparent',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: 'transparent',
                        boxShadow: 'none',
                      },
                    },
                    width: '32.051vw'
                  }}
                >
                  <InputLabel id="skill-labels">Skill</InputLabel>
                    <Select
                      labelId="skill-label"
                      id="skill-select"
                      label="Skill"
                      value={selectedSkill}
                      onChange={handleSkillChange}
                    >
                      <MenuItem value="">None</MenuItem>
                      {skills.map((skill) => (
                        <MenuItem key={skill.skill_id} value={skill.skill_id}>
                          {skill.skill_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl
                  fullWidth
                  className="mb-3 customTextfield"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: 'transparent',
                      },
                      '&:hover fieldset': {
                        borderColor: 'transparent',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: 'transparent',
                        boxShadow: 'none',
                      },
                    },
                    width: '32.051vw'
                  }}
                >
                  <InputLabel id="war-label">War</InputLabel>
                    <Select
                      labelId="war-label"
                      id="war-select"
                      label="War"
                      value={selectedWar}
                      onChange={(e) => {
                        setSelectedWar(e.target.value);
                      }}
                    >
                      <MenuItem value="">None</MenuItem>
                      {wars.map((war) => (
                        <MenuItem key={war.war_id} value={war.war_id}>
                          {war.war_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div className="rightFields">
                  {/* <TextField
                    label="Name"
                    variant="outlined"
                    value={filter}
                    fullWidth
                    onChange={handleInputChange}
                    placeholder="Enter Name"
                    className="mb-3 customTextfield"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: 'transparent',
                        },
                        '&:hover fieldset': {
                          borderColor: 'transparent',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: 'transparent',
                          boxShadow: 'none',
                        },
                      },
                      width: '32.051vw'
                    }}
                  /> */}
                  <Autocomplete
                    id="userId"
                    options={users}
                    getOptionLabel={(option) => option.username}
                    value={filter ? users.find((user) => user.username === filter) : null}
                    onChange={handleInputChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        // label="Name"
                        variant="outlined"
                        // value={filter}
                        fullWidth
                        // onChange={handleInputChange}
                        placeholder="Username"
                        className="mb-3 customTextfield"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                              borderColor: 'transparent',
                            },
                            '&:hover fieldset': {
                              borderColor: 'transparent',
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: 'transparent',
                              boxShadow: 'none',
                            },
                          },
                          width: '32.051vw'
                        }}
                      />
                    )}
                  />
                </div>
              </div>
                  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '1.3vw', }}>
                    <Button
                      variant="outlined"
                      className="outlined-button"
                      onClick={handleReset}
                    >
                      Reset
                    </Button>
                    <Button
                      variant="contained"
                      // color="primary"
                      onClick={handleExportClick}
                      className="filled-button"
                      style={{
                        height: '2.564vw',
                        width: '15.385vw',
                        borderRadius: '4px',
                        textTransform: 'capitalize',
                        color: '#fff',
                        backgroundColor: '#37446F'
                      }}
                    >
                      Export
                    </Button>
                  </div>
                </div>
                {
                  reports.length > 0 && (
                  <table className="table mt-5">
                    <thead className="table-head">
                      <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Class</th>
                        <th>Earned/Total Score</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reports
                        ?.filter(
                          (report) =>
                            (!filter ||
                              report.name
                                ?.toLowerCase()
                                .includes(filter?.toLowerCase()) ||
                              filter === "") &&
                            (!selectedWar ||
                              report.war_id?.toString().includes(selectedWar) ||
                              selectedWar === "") &&
                            (!selectedSkill ||
                              report.skill_id
                                ?.toString()
                                .includes(selectedSkill) ||
                              selectedSkill === "")
                        )
                        .map((filteredReport) => (
                          <tr key={filteredReport.attempt_id}>
                            <td>{filteredReport.attempt_id}</td>
                            <td>{filteredReport.name}</td>
                            <td>{filteredReport.user_class}</td>
                            <td>{`${filteredReport.total_correct}/${filteredReport.total_questions}`}</td>
                            <td>{formatTime(filteredReport.start_time)}</td>
                            <td>{formatTime(filteredReport.end_time)}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  )
                }
            </div>
          </CardContent>
      </div>
    </div>
      ) : (
        <WarReportMobile />
      )
    }
    </>
  );
};

export default WarReport;
